var UnicornCelebration = require('./UnicornCelebration');
var UnicornCelebrationContainer = require('./UnicornCelebrationContainer');
var useUnicornCelebration = require('./useUnicornCelebration');
var Unicorn = require('./Unicorn');
var RainbowTrail = require('./RainbowTrail');
var {
  useBezierPath,
  generateRandomPath,
  getPointOnPath,
  getAngleOnPath,
} = require('./useBezierPath');
var {
  useUnicornAnimation,
  useCelebrationState,
  shouldBeStampede,
  generateUnicornConfigs,
} = require('./useUnicornAnimation');

module.exports = {
  UnicornCelebration: UnicornCelebration,
  UnicornCelebrationContainer: UnicornCelebrationContainer,
  useUnicornCelebration: useUnicornCelebration,
  Unicorn: Unicorn,
  RainbowTrail: RainbowTrail,
  useBezierPath: useBezierPath,
  generateRandomPath: generateRandomPath,
  getPointOnPath: getPointOnPath,
  getAngleOnPath: getAngleOnPath,
  useUnicornAnimation: useUnicornAnimation,
  useCelebrationState: useCelebrationState,
  shouldBeStampede: shouldBeStampede,
  generateUnicornConfigs: generateUnicornConfigs,
};
